import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function upload(data) {
  return await request({
    url: ENDPOINT.UPLOAD,
    method: "post",
    data,
  });
}